module.exports = __webpack_public_path__ + "img/ics_f_thumb-good-disabled.1b969cd8.svg";